/* eslint semi:0 */
import { makeSafeFn, } from 'utils/fn'
import { twitter, } from 'config/externalScripts'
import { registerProvider, } from 'application/nm'
import { external as externalScriptsLoader, } from 'utils/script'

const TW_CONTAINER_SELECTOR = '.tweet-container'

export default function initTwitterEmbeds(){
  if (document.querySelector(TW_CONTAINER_SELECTOR)) {
    const twitterLoader = externalScriptsLoader.load({ name: twitter.name, })
    twitterLoader(
      makeSafeFn(() => window.twttr.widgets.load())
    )
    return true
  }
  return false
}

registerProvider({ initTwitterEmbeds, })


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/twitter/twitterEmbedProvider.js